import { PHOTO_GALLERY_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const photoGalleryInitialState = {
  data: [],
  photoGallery: {},
  formError: {},
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function photoGalleryReducer(state = photoGalleryInitialState, action) {
  switch (action.type) {
    case PHOTO_GALLERY_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
